// 路由白名单
export const passRoute = [
  '/login',
  '/UserInfoHandle',
  '/thirdPartLogin',
  '/exchange/home',
  '/other/jinKo/*',
  '/paymentCashier',
  '/payOrderStatus'
  // '/other/jinKo/home'
]

export const passRouteHandle = (to, from, next) => {
   const isPassRoute = passRoute.some(route => {
     if (route.includes('*')) {
       const baseRoute = route.replace('*', '')
       return to.path.startsWith(baseRoute)
     }
     return to.path === route
   })

   return isPassRoute
}
